/* ReFramed premium sections (for the Clean Slate theme): carousel arrows,
   collection tabs and quick add. Quick add hands off to the theme's own
   add-to-cart notification by dispatching its cart events. */
(function () {
  'use strict';
  if (window.RFS) return;
  var RFS = window.RFS = {};
  var qs = function (s, el) { return (el || document).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var debounce = function (fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; };

  function toast(msg) {
    var t = document.createElement('div');
    t.setAttribute('role', 'status');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#0b0b0b;color:#fff;padding:12px 18px;font:13px/1.4 var(--font-body--family,inherit);z-index:100000;max-width:calc(100vw - 32px);text-align:center';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3200);
  }

  function initRails(scope) {
    qsa('[data-rf-rail-wrap]', scope).forEach(function (w) {
      if (w._rf) return; w._rf = 1;
      var prev = qs('[data-rf-rail-prev]', w), next = qs('[data-rf-rail-next]', w);
      var rail = function () { return qsa('.rf-rail', w).filter(function (r) { return !r.closest('[hidden]'); })[0]; };
      var upd = function () { var r = rail(); if (!r) return; if (prev) prev.disabled = r.scrollLeft < 4; if (next) next.disabled = r.scrollLeft + r.clientWidth > r.scrollWidth - 4; };
      var step = function (d) { var r = rail(); if (r) r.scrollBy({ left: d * r.clientWidth * 0.8, behavior: 'smooth' }); };
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      qsa('.rf-rail', w).forEach(function (r) { r.addEventListener('scroll', debounce(upd, 60), { passive: true }); });
      w.addEventListener('click', function (e) { if (e.target.closest('[data-rf-tab]')) setTimeout(upd, 30); });
      upd();
    });
    qsa('[data-rf-tabs]', scope).forEach(function (w) {
      if (w._rft) return; w._rft = 1;
      w.addEventListener('click', function (e) {
        var t = e.target.closest('[data-rf-tab]'); if (!t) return;
        qsa('[data-rf-tab]', w).forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
        qsa('[data-rf-tabpanel]', w).forEach(function (p) { p.hidden = p.getAttribute('data-rf-tabpanel') !== t.getAttribute('data-rf-tab'); });
        var link = qs('[data-rf-tab-link]', w); if (link && t.getAttribute('data-url')) link.href = t.getAttribute('data-url');
      });
    });
  }
  RFS.initRails = initRails;

  /* quick add on premium product cards */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-rf-qa-toggle]');
    if (t) { e.preventDefault(); var card = t.closest('[data-rf-card]'); var was = card.classList.contains('is-qa-open'); qsa('.rf-card.is-qa-open').forEach(function (c) { c.classList.remove('is-qa-open'); }); if (!was) card.classList.add('is-qa-open'); return; }
    var b = e.target.closest('[data-rf-qa]');
    if (!b) { if (!e.target.closest('.rf-card__qa')) qsa('.rf-card.is-qa-open').forEach(function (c) { c.classList.remove('is-qa-open'); }); return; }
    e.preventDefault();
    if (b.classList.contains('is-added')) return;
    b.classList.add('is-added');
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-rf-qa'), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); })
      .then(function (d) {
        var item = (d.items && d.items[0]) || d;
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: item } }));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var c = b.closest('[data-rf-card]'); if (c) c.classList.remove('is-qa-open');
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () { setTimeout(function () { b.classList.remove('is-added'); }, 900); });
  });

  function init() { initRails(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initRails(e.target); });
})();
